import { useContext, useState } from "react";
import { extractYear } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";
import styles from "./css/styles.module.css";
import DocumentBar from "./DocumentBar";
import apiCall from "../../../utils/apiCall";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from "../../../providers/notification";
import { NotAvailable } from "./styles";
import { ApplicationsContext } from "../Applications/Applications";
import { ExNyRoute } from "../../../utils/allRouteId";
import { qualificationData, QualificationsProps } from "./type";

interface Payload {
  id?: number;
  applicantId?: string;
  qualificationId?: number;
  score: number;
}

const QualificationDiv: React.FC<QualificationsProps> = ({
  data,
  nyscDischargeCertData,
  routeId,
  handleCancel,
}) => {
  const [isOLevel, setIsOLevel] = useState(false);
  const [isNysc, setIsNysc] = useState(false);

  const [id, setId] = useState<number | undefined>(0);
  const [applicantId, setApplicantId] = useState<string | undefined>("");
  const [qualificationId, setQualificationId] = useState<number | undefined>(0);
  const [score, setScore] = useState("");

  const queryClient = useQueryClient();
  const { showNotification } = useContext(NotificationContext);

  const handleScore = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScore(event.target.value);
  };

  const handleOlevel = (data?: qualificationData) => {
    setIsOLevel(!isOLevel);
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
    setQualificationId(data?.QualificationId);
    setScore("");
  };

  const handleNysc = (data?: qualificationData) => {
    setIsNysc(!isNysc);
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
    setQualificationId(data?.QualificationId);
    setScore("");
  };

  const url = `/Applicant/UpdateScoreAcademicByApplicantId?id=${id}&applicantId=${applicantId}&qualificationId=${qualificationId}&score=${Number(
    score
  )}`;

  const updateAcademicScore = async (data: Payload) => {
    return await apiCall().post(url, data);
  };

  const { isApplicationMenu } = useContext(ApplicationsContext);

  const updateAcademicScoreMutation = useMutation(
    ["update-score"],
    updateAcademicScore,
    { retry: 0 }
  );

  const updateAcademicScoreHandler = async () => {
    const payload: Payload = {
      id: id,
      applicantId: applicantId,
      qualificationId: qualificationId,
      score: Number(score),
    };

    try {
      await updateAcademicScoreMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "Academic Score has been successfully updated",
          });
          queryClient.refetchQueries(["qalifications"]);
          queryClient.refetchQueries(["get-all-personal-details"]);
          queryClient.refetchQueries(["get-approval"]);
          //queryClient.refetchQueries(['get-all-personal-details']);
          setIsOLevel(false);
          setScore("");
          //handleCancel(false);
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  const showScoresUpdate =
    routeId == Number(ExNyRoute) || isApplicationMenu ? false : true;

  return (
    <div className={`${css.edDiv} ${css.educationalD}`}>
      <p className={css.title}>Educational Background</p>

      {data &&
        data?.map((item) => (
          <>
            <div className={styles.headingBar} key={item?.Id}>
              {item?.Qualification}
            </div>

            <div style={{ overflowX: "auto" }}>
              <table>
                <tr className={styles.tableHead}>
                  <th>Name of Institution</th>
                  <th>Discipline</th>
                  <th>Qualification</th>
                  <th>Year</th>
                  <th>Uploaded Document</th>
                </tr>
                <tr>
                  <td> {item?.InstitutionName}</td>
                  <td> {item?.Discipline}</td>
                  <td> {item?.Qualification}</td>
                  <td> {extractYear(item?.GraduateDate)}</td>
                  <td>
                    <DocumentBar
                      hideScoreIntegration={showScoresUpdate}
                      onChange={handleScore}
                      docName={""}
                      documentUrl={item?.CertificateUrl}
                      score={score}
                      displayScore={item?.Score}
                      handleVisibility={() => handleOlevel(item)}
                      handleSubmit={updateAcademicScoreHandler}
                      loading={updateAcademicScoreMutation?.isLoading}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        ))}

      {!(routeId == Number(ExNyRoute)) && (
        <>
          <div className={styles.headingBar}>NYSC DISCHARGE CERTIFICATE</div>
          {nyscDischargeCertData?.ApplicantId ? (
            <DocumentBar
              docName={"NYSC DISCHARGE CERTIFICATE"}
              documentUrl={nyscDischargeCertData?.CertificateUrl}
              score={200}
              displayScore={200}
              handleVisibility={handleNysc}
              onChange={handleScore}
              hideScoreIntegration={false}
            />
          ) : (
            <NotAvailable>Not Available</NotAvailable>
          )}
        </>
      )}
    </div>
  );
};

export default QualificationDiv;
